export default __webpack_public_path__ + "static/media/web_screen_meetings_en.2e9cf06d.png";